import { React, useEffect, useState } from 'react';

import {
  Dialog,
  TextInputField,
  FormField,
  Button,
  Pane,
  Menu,
  Popover,
  SelectField,
} from 'evergreen-ui';
import { Container, Row, Col } from 'react-grid-system';

import { mutate } from 'swr';
import { useForm } from 'react-hook-form';

import { putAccountPlan } from '../../../services/api/accountPlansService';
import { useQueryDreGrouping } from '../../../services/api/dreGroupingService';
import { toastNotification } from '../../../shared/toastNotification';

import { inputValidation } from '../../../helpers/formHelper';

function AccountPlanEditFormComponent({ isShown, setIsShown, accountPlan = {} }) {
  const companyId = localStorage.getItem('companyId');
  /* API calls */

  const { data: dreGrouping = [], isLoading: isLoadingDreGrouping } = useQueryDreGrouping(
    // company.data.id,
    companyId,
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  const [isDisabled, setIsDisabled] = useState(true);

  /* Form */

  const { formState, register, handleSubmit, reset, setValue, watch } = useForm({
    defaultValues: accountPlan,
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    inputValidation(watch('name'), watch('isInput'), setIsDisabled);
  }, [watch('isInput'), watch('name')]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    reset(accountPlan);
  }, [isShown]);

  const accountPlanFormFooter = () => {
    return (
      <Pane>
        <Button
          form="accountPlan-form"
          type="submit"
          width="fit-content"
          id="onSubmit"
          disabled={isDisabled}
        >
          Salvar
        </Button>
      </Pane>
    );
  };

  const onSubmit = (accountPlan) => {
    console.log('onSubmit');
    let statusResponse = false;
    let toastContent = '';
    console.log('AccPlan', accountPlan);

    let accountPlanToUpdate = {
      id: accountPlan.id,
      name: accountPlan.name,
      dreGroupingId: accountPlan.dreGroupingId,
    };

    putAccountPlan(accountPlanToUpdate)
      .then((res) => {
        console.log('res put accountPlan: ', res);
        mutate(`accountPlans-${companyId}`);
        // Also mutate categories since they depend on accountPlans
        mutate(`categories-${companyId}`);
        statusResponse = 'success';
        toastContent = 'Edição salva.';
        onClose();
      })
      .catch((err) => {
        console.log('put err', err);
        statusResponse = 'warning';
        toastContent = `Erro. Verifique os campos novamente.`;
      })
      .finally(() => {
        toastNotification(statusResponse, toastContent);
      });
  };

  const onClose = () => {
    console.log('onClose function');
    reset();
    setIsShown(false);
  };

  return (
    <Dialog
      isShown={isShown}
      title="Editar Plano de Conta"
      onCloseComplete={onClose}
      confirmLabel="Custom Label"
      hasFooter={true}
      footer={accountPlanFormFooter}
      shouldCloseOnEscapePress={!formState.isDirty}
      width={800}
      backgroundColor="#f8f8f8"
    >
      <div>
        <form id="accountPlan-form" onSubmit={handleSubmit(onSubmit)}>
          <FormField>
            <Container
              fluid={true}
              style={{
                width: '100%',
                margin: 'none',
                padding: 'none',
              }}
            >
              <Row>
                <Col sm={12} md={12} lg={6}>
                  <TextInputField
                    {...register('name')}
                    label="Plano de Conta"
                    id="name"
                    name="name"
                    type="text"
                  />
                </Col>
                <Col sm={12} md={12} lg={6}>
                  <SelectField
                    {...register('dreGroupingId')}
                    label="Agrupamento"
                    onChange={(e) => setValue('dreGroupingId', e.target.value)}
                  >
                    {!isLoadingDreGrouping &&
                      dreGrouping &&
                      dreGrouping.data &&
                      Array.isArray(dreGrouping.data) &&
                      dreGrouping.data
                        .filter((dre) => {
                          return dre.isInput === watch('isInput');
                        })
                        .map((item) => {
                          return (
                            <option key={item.id} value={item.id}>
                              {item.name}
                            </option>
                          );
                        })}
                  </SelectField>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Popover
                    content={
                      <Menu
                        {...register('isInput', {
                          value: undefined,
                        })}
                      >
                        <Menu.Group>
                          <Menu.Item
                            onSelect={() => {
                              setValue('isInput', true);
                            }}
                          >
                            Entrada
                          </Menu.Item>
                          <Menu.Item
                            onSelect={() => {
                              setValue('isInput', false);
                            }}
                          >
                            Saída
                          </Menu.Item>
                        </Menu.Group>
                      </Menu>
                    }
                  >
                    <Button marginRight={16} id="categoryType" type="button" disabled={true}>
                      {(watch('isInput') ? 'Entrada' : 'Saída') || 'Classificação'}
                    </Button>
                  </Popover>
                </Col>
              </Row>
            </Container>
          </FormField>
        </form>
      </div>
    </Dialog>
  );
}

export default AccountPlanEditFormComponent;
